// this file added for individual by Bearer Web Developer
import { Button } from "@mui/material";
import { Observer } from "mobx-react-lite";
import React, { useMemo, useRef, useState } from "react";
import styles from './enterTheCode.module.scss';
import { useAppState } from "../../../states/app-state";
import { SigninSituation } from "../../../states/signinState";
import { validateCode } from "./validate";
import Second from "./second";

const EnterTheCode: React.FC = () => {

    const [error, setError] = React.useState('');
    const appState = useAppState();
    const { login, signin } = appState;
    const inputs = useRef<Array<HTMLInputElement | null>>([]);
    const code = inputs.current.map((input) => input?.value || "").join("");
    const [otp, setOtp] = useState(code); // otp is stand by One-Time Password
    const valid = useMemo(() => {
        return !validateCode(otp);
    }, [otp]);
    const enterCodeSituation =
        signin.situation === SigninSituation.EnterCodeForSignin || signin.situation === SigninSituation.EnterCodeForSignup;
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (valid) {
            try {
                if (error) setError('');
                signin.setLoading(true);
                if (!enterCodeSituation) setError("code is expired")
                else {
                    console.log({ otp });
                    const user = await signin.confirmationResultCode(otp);
                    if (user && user.phoneNumber && !login.mobileNumber) {
                        const phoneNumber = user.phoneNumber?.toString();
                        const mobileNumber = phoneNumber.startsWith("+61") ? phoneNumber.slice(3) : phoneNumber;
                        login.setMobileNumber(mobileNumber);
                    }
                    if (user && user.uid) await appState.login.login(user.uid, true);
                }
                if (signin.loading) signin.setLoading(false);
                handleClose();
            } catch (err: any) {
                signin.setLoading(false);
                if (err?.message === "Firebase: Error (auth/invalid-verification-code).") {
                    setError("The entered code is invalid");
                } else if (err?.message === "Firebase: Error (auth/missing-verification-code).") {
                    setError("please enter the code");
                } else if (err?.message === "Firebase: Error (auth/code-expired).") {
                    setError("code is expired");
                } else if (err?.message) {
                    setError(err?.message);
                }
                console.log(err?.message);
                console.log(err);
            }
        }
    }
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const value = e.target.value;
        if (error) setError('');
        // only number and one number
        if (!/^\d?$/.test(value)) {
            // if it is not a nmuber remove it
            e.target.value = "";
            const code = inputs.current.map((input) => input?.value || "").join("");
            setOtp(code);
            return;
        } else {
            const code = inputs.current.map((input) => input?.value || "").join("");
            setOtp(code);
        }
        if (value && index < 5) {
            // go next
            inputs.current[index + 1]?.focus();
        }

        if (!value && index > 0) {
            // go back 
            inputs.current[index - 1]?.focus();
        }
    };
    const handleClose = async () => {
        try {
            const beforeSituation = appState?.signin.situation;
            if (beforeSituation === SigninSituation.ReadyForSignup) return;
            if (beforeSituation === SigninSituation.Loggedin) {
                login.setOpen(false);
                return;
            }
            // if beforeSituation was Expired reset is not needed, Recaptcha is already reset (just after finishing the time for entering the code)
            if (beforeSituation === SigninSituation.CodeExpiredForSignin || beforeSituation === SigninSituation.CodeExpiredForSignup) {
                const newSituation = beforeSituation === SigninSituation.CodeExpiredForSignin ?
                    SigninSituation.Login : SigninSituation.CreateAccount
                appState?.signin.setSituation(newSituation);
            } else {
                signin.setLoading(true);
                const resetResult = await appState.signin.resetRecaptcha();
                signin.setLoading(false);
                if (resetResult) {
                    const newSituation = beforeSituation === SigninSituation.EnterCodeForSignin || SigninSituation.CodeExpiredForSignin ?
                        SigninSituation.Login : SigninSituation.CreateAccount;
                    appState?.signin.setSituation(newSituation);
                }
            }
        } catch (error) {
            signin.setLoading(false);
            console.log(error);
        }
    }
    return (
        <div className={styles.main}>
            <div className={styles.header}>
                <h2>{`+ 61 ${login.mobileNumber}`}</h2>
                <Button className={styles.back} disableRipple={true} onClick={handleClose}>
                    <img src="/back.png" alt="back" />
                </Button>
            </div>
            <p className={styles.verify}>Please enter the code sent to your mobile phone</p>
            <form onSubmit={handleSubmit}>
                <Observer>{() => (
                    <div className={styles.inputs}>
                        {
                            [...Array(6)].map((_, index) => (
                                <input
                                    key={index}
                                    type="tel"
                                    inputMode="numeric"
                                    maxLength={1}
                                    placeholder="---"
                                    className=""
                                    onChange={(e) => handleChange(e, index)}
                                    ref={(el) => {
                                        inputs.current[index] = el
                                    }}
                                />
                            ))
                        }
                    </div>
                )}</Observer>
                {error && <div className={styles.error}>{error}</div>}  {/* added by Bearer Web Developer */}
                <Second />
                <Observer>{() => {
                    return (
                        <>
                            <Button
                                type='submit'
                                className={styles.submit}
                                variant="text"
                                color="primary"
                                fullWidth
                                disabled={!valid}
                                disableRipple={true}
                            >
                                Submit
                            </Button>
                        </>
                    )
                }}</Observer>
            </form>
        </div>
    )
}
export default EnterTheCode;